import { useIntl } from "react-intl";
import { ReactComponent as GroupIconSVG } from "../../assets/group-icon-small.svg";
import { ReactComponent as PlusSVG } from "../../assets/plus-thin.svg";

import GroupItem from "./GroupItem";

import { useOutletContext } from "react-router-dom";
import { MainPageOutletContext } from "../main/Main";
import "./group.scss";

function AddGroup() {
  const { formatMessage } = useIntl();
  const outlet = useOutletContext<MainPageOutletContext>();

  return (
    <GroupItem
      to={outlet.generatePath("/group/create")}
      className="create-group"
    >
      <div className="text">
        <PlusSVG width={24} height={24} />
        <GroupIconSVG width={32} height={32} />
        {formatMessage({ id: "group.create" })}
      </div>
    </GroupItem>
  );
}

export default AddGroup;
